(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
  (() => {
    const cartRoot = document.getElementById('MinimogCart');
    if (!cartRoot || cartRoot.dataset.stridemartCartSync === 'true') return;

    cartRoot.dataset.stridemartCartSync = 'true';
    let syncTimer;

    const syncHeaderCartCount = async () => {
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart.js', {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return;

        const cart = await response.json();
        document.querySelectorAll('.smv2-cart-count').forEach((count) => {
          count.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
          count.hidden = cart.item_count === 0;
        });
      } catch (error) {
        console.warn('StrideMart cart count sync failed.', error);
      }
    };

    const queueCartCountSync = () => {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncHeaderCartCount, 120);
    };

    new MutationObserver(queueCartCountSync).observe(cartRoot, {
      childList: true,
      subtree: true
    });

    window.addEventListener('pageshow', syncHeaderCartCount);
    syncHeaderCartCount();
  })();

  } catch(e) { console.error(e); }
})();
})();
